import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container">
          <div className="footer__grid">
            <div className="footer__brand">
              <h3 className="footer__logo">RK Overseas</h3>
              <p className="footer__tagline">Est. 1997</p>
              <p className="footer__desc">
                Established in 1997, the factory specializes in in-house mouth
                blown glass manufacturing, supported by a team of highly skilled
                craftsmen dedicated to creating unique products in the market.
              </p>
            </div>

            <div className="footer__col">
              <h4>Quick Links</h4>
              <ul>
                {[
                  { to: "/about", label: "About Us" },
                  { to: "/product", label: "Products" },
                  { to: "/catalogue", label: "Catalogue" },
                  { to: "/client", label: "Clients" },
                  { to: "/contact", label: "Contact Us" },
                ].map(({ to, label }) => (
                  <li key={to}>
                    <Link to={to} aria-label={`Go to ${label} page`}>
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer__col">
              <h4>Factory Address</h4>
              <ul className="footer__contact">
                <li>
                  <span className="footer__icon">📞</span>
                  <a href="tel:+919557306306" aria-label="Call RK Overseas">
                    +91 9557306306
                  </a>
                </li>
                <li>
                  <span className="footer__icon">✉️</span>
                  <a
                    href="mailto:skinirdosh@gmail.com"
                    aria-label="Email RK Overseas"
                  >
                    skinirdosh@gmail.com
                  </a>
                </li>
                <li>
                  <span className="footer__icon">📍</span>
                  <span>B-5,6 UPSIDC, Firozabad-283203, India</span>
                </li>
              </ul>
            </div>

            <div className="footer__col">
              <h4>Showroom Address</h4>
              <ul className="footer__contact">
                <li>
                  <span className="footer__icon">📞</span>
                  <a href="tel:+919557306306">+91 9557306306</a>
                </li>
                <li>
                  <span className="footer__icon">✉️</span>
                  <a href="mailto:skinirdosh@gmail.com">skinirdosh@gmail.com</a>
                </li>
                <li>
                  <span className="footer__icon">📍</span>
                  <span>B-5,6 UPSIDC, Firozabad-283203, India</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer__bottom">
        <div className="container">
          <p>© {new Date().getFullYear()} RK Overseas. All Rights Reserved.</p>
          <p>
            Manufacturer & Exporter of Glass Decorative Items — Firozabad, India
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
